var _circle, _circle2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 31,
    fill: "url(#paint0_linear_208_12771)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35.5,
    stroke: "url(#paint1_linear_208_12771)",
    strokeOpacity: 0.1,
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 53.6C37 53.0477 37.4477 52.6 38 52.6H42.4C42.9523 52.6 43.4 53.0477 43.4 53.6V58C43.4 58.5523 42.9523 59 42.4 59H38C37.4477 59 37 58.5523 37 58V53.6ZM37 23C37 22.4477 37.4477 22 38 22H42.4C42.9523 22 43.4 22.4477 43.4 23V45.1999C43.4 45.7522 42.9523 46.1999 42.4 46.1999H38C37.4477 46.1999 37 45.7522 37 45.1999V23Z",
    fill: "#16191E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_12771",
    x1: 40,
    y1: 70.8454,
    x2: 40,
    y2: 9.05417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1EE0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3EE13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_12771",
    x1: 70.9457,
    y1: 40,
    x2: 9.05426,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1EE0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3EE13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.eb4e8a52a947f988136ee63f5a9cd0e9.svg";
export { ForwardRef as ReactComponent };